import P2PPlatform from '../../../styles/svg/p2p-platform.svg';

export const loginCarousel = [
  {
    title: 'ATRS Platform',
    description: '',
    icon: P2PPlatform,
  },
];
